import type { SaleInstallmentInput } from '@/types/saleInstallment';

export function validatePercentages(
  installments: SaleInstallmentInput[]
): { valid: boolean; sum: number } {
  const sum = installments.reduce((acc, inst) => acc + inst.percentage, 0);
  return { valid: Math.abs(sum - 100) < 0.01, sum };
}

export function splitIntoInstallments(
  totalValue: number,
  numInstallments: number
): number[] {
  if (numInstallments <= 0) return [];
  if (numInstallments === 1) return [Math.round(totalValue * 100) / 100];
  
  // Arredonda o valor total para evitar erros de ponto flutuante
  const safeTotal = Math.round(totalValue * 100) / 100;
  const baseAmount = Math.floor(safeTotal * 100 / numInstallments) / 100;
  
  const amounts = new Array(numInstallments).fill(baseAmount);
  
  // Calcular diferença e atribuir à ÚLTIMA parcela (padrão fiscal)
  const currentSum = Math.round(baseAmount * numInstallments * 100) / 100;
  const difference = Math.round((safeTotal - currentSum) * 100) / 100;
  amounts[amounts.length - 1] = Math.round((baseAmount + difference) * 100) / 100;
  
  return amounts;
}

export function splitPercentages(numInstallments: number): number[] {
  if (numInstallments <= 0) return [];
  if (numInstallments === 1) return [100];
  
  const basePercentage = Math.floor((100 / numInstallments) * 100) / 100;
  const percentages = new Array(numInstallments).fill(basePercentage);
  
  // Ajusta a ÚLTIMA para garantir 100% (padrão fiscal)
  const currentSum = Math.round(basePercentage * numInstallments * 100) / 100;
  const difference = Math.round((100 - currentSum) * 100) / 100;
  percentages[percentages.length - 1] = Math.round((basePercentage + difference) * 100) / 100;
  
  return percentages;
}
